import { useEffect, useState } from 'react'
import { Logo } from '../ui/controls.jsx'

const signedOutCookie = () => document.cookie.split('; ').some((c) => c === 'yokan_signedout=1')
// Another *.yokan.io app holds a session → go straight into SSO (same as the dashboard).
const activeYokanSession = () => document.cookie.split('; ').some((c) => c === 'yokan_active=1')

function loginUrl() {
  const redirect = window.location.pathname + window.location.search
  return redirect && redirect !== '/' ? `/auth/login?redirect=${encodeURIComponent(redirect)}` : '/auth/login'
}

export default function LoginPage() {
  const [signedOut] = useState(signedOutCookie)
  useEffect(() => {
    if (!signedOut && activeYokanSession()) window.location.replace(loginUrl())
  }, [signedOut])
  return (
    <div className="h-full flex items-center justify-center p-6 viewport-ground">
      <div className="inner-panel bg-surface-container p-8 flex flex-col items-center gap-5 text-center" style={{ width: '100%', maxWidth: 360, border: '1px solid var(--line)', borderRadius: 16 }}>
        <Logo size={40} />
        <div className="flex flex-col gap-1.5">
          <div className="font-headline font-bold" style={{ fontSize: 22, letterSpacing: '-0.02em' }}>{signedOut ? 'Abgemeldet' : 'Mori'}</div>
          <div className="ds-text-desc">{signedOut ? 'Melde dich wieder an, wenn du so weit bist.' : 'Holzprojekte planen — vom 3D-Modell bis zur Zuschnittliste.'}</div>
        </div>
        <button type="button" className="btn btn-primary btn-lg w-full" onClick={() => window.location.assign(loginUrl())}>Mit YOKAN anmelden</button>
      </div>
    </div>
  )
}
